export class NotFoundError extends Error {
    entity: string; 
    identifier: string;
    
    constructor(entity: string, identifier: string) {
        super(entity + '|' + identifier);
        this.entity = entity;
        this.identifier = identifier;
    }
}